import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect } from 'react';
import { getProductNameTextFromApiName } from '../../_core/common/adapters/getProductNameText';
import { REMOVE_BRANDING_BANNER } from '../../_core/common/constants/PurchaseMotionLocations';
import { track } from '../../_core/common/eventTracking/tracker';
import { PRICING_PAGE_REDIRECT } from '../../_core/purchaseMotions/PurchaseMotionTypes';
import getUpgradeBannerTranslations from '../../_core/utils/getUpgradeBannerTranslations';
import { getUpgradeDataFromUpgradeConfig } from '../../_core/utils/getUpgradeDataFromUpgradeConfig';
import UIPurchaseMotionButton from '../../button/UIPurchaseMotionButton';
import { getBannerI18nTitleKey, getUpgradeConfigTrackingProperties, updateViewedUpgradePointsCache } from '../utils';
import BuiltOnHubSpotBadge from './BuiltOnHubSpotBadge';
import DefaultBanner from './DefaultBanner';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RemoveBrandingBanner = ({
  upgradePoint,
  marginStyle,
  'data-test-id': dataTestId = 'locked-feature-banner'
}) => {
  const upgradeData = getUpgradeDataFromUpgradeConfig(upgradePoint);
  useEffect(() => {
    updateViewedUpgradePointsCache(upgradePoint.upgradeKey, () => {
      track('interaction', Object.assign({
        action: 'viewed upgrade point'
      }, getUpgradeConfigTrackingProperties(upgradePoint)));
    });
  }, [upgradePoint]);
  const {
    bannerTitle,
    bannerSubtitle
  } = getUpgradeBannerTranslations(upgradePoint.descriptions);
  return /*#__PURE__*/_jsx(DefaultBanner, {
    marginStyle: marginStyle,
    dataTestId: dataTestId,
    replacementIcon: /*#__PURE__*/_jsx(BuiltOnHubSpotBadge, {}),
    titleText: bannerTitle ? /*#__PURE__*/_jsx(_Fragment, {
      children: bannerTitle
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: getBannerI18nTitleKey('upgrades.removeBrandingBanner.titles', upgradePoint.featureTranslationKey)
    }),
    subtext: bannerSubtitle ? /*#__PURE__*/_jsx(_Fragment, {
      children: bannerSubtitle
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.lockedFeatureBanner.text"
      }), "\xA0", /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.message.productName",
        options: {
          productName: getProductNameTextFromApiName(upgradeData.apiName)
        }
      })]
    }),
    button: /*#__PURE__*/_jsx(UIPurchaseMotionButton, {
      upgradeData: upgradeData,
      location: REMOVE_BRANDING_BANNER,
      level: 1,
      use: "link",
      purchaseMotions: [PRICING_PAGE_REDIRECT],
      "data-test-id": "upgrade-button",
      isUpgradePoint: true,
      goToUpgradePage: true,
      truncate: false,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.upgradeButton.default"
      })
    })
  });
};
export default RemoveBrandingBanner;